import { apiRequest } from '../api';
import { WCA_BOTFLOW } from '../endPoints';

export const wcaGetAllBotFlows = (pageNo = 0, limit = 30) => {
  const params = {
    page: pageNo,
    limit,
  };

  return apiRequest('get', WCA_BOTFLOW.ROOT(), null, params);
};

export const wcaCreateBotFlow = (data) => {
  return apiRequest('post', WCA_BOTFLOW.ROOT(), data);
};

export const wcaUpdateBotFlowDetails = (id, data) => {
  return apiRequest('put', WCA_BOTFLOW.BY_ID(id), data);
};

export const wcaPublishBotFlow = (id, data) => {
  return apiRequest('post', WCA_BOTFLOW.PUBLISH(id), data);
};

export const wcaGetBotFlowSchema = (id) => {
  return apiRequest('get', WCA_BOTFLOW.SCHEMA(id));
};

export const wcaSaveBotFlowSchema = (id, data) => {
  return apiRequest('post', WCA_BOTFLOW.SCHEMA(id), data);
};

export const wcaGetBotFlowSchemaVersion = (id, version) => {
  return apiRequest('get', WCA_BOTFLOW.SCHEMA_VERSION(id, version));
};
